import { createSelector } from 'reselect';

// Collection modifiyers
const mapCountriesAreas = ({ code, full_name, country }) => ({
  value: code || country,
  label: full_name || country,
  country: country,
  values: {
    area: code || null,
    country: !code ? country : null,
  },
});

const mapCountries = (countriesAndAreas, country) =>
  !countriesAndAreas.some((i) => i.value === country) ? [mapCountriesAreas({ country })] : [];

const countriesAndAreas = (acc, area) => [...acc, ...[area], ...mapCountries(acc, area.country)];

// Filters
function activatedArea(area) {
  return area.code !== 'OTH' && area.code.charAt(0) !== '_';
}

function greaterCountry(a, b) {
  return a.country.toUpperCase() > b.country.toUpperCase();
}

function countryVsArea(a, b) {
  return equalCountries(a, b) && a.values.country && b.values.area;
}

function greaterArea(a, b) {
  return (
    equalCountries(a, b) &&
    a.values.area &&
    b.values.area &&
    a.label.toUpperCase() > b.label.toUpperCase()
  );
}

function equalCountries(a, b) {
  return a.country === b.country;
}

// Sorts
function sortCountriesAndAreas(a, b) {
  if (greaterCountry(b, a) || countryVsArea(a, b) || greaterArea(b, a)) {
    return -1;
  }

  if (greaterCountry(a, b) || countryVsArea(b, a) || greaterArea(a, b)) {
    return 1;
  }
  return 0;
}

const getAreas = (state) => state.areas.data;

const getAddedAreas = createSelector(getAreas, (areas) =>
  areas.filter(activatedArea).map(mapCountriesAreas)
);

const getCountriesAndAreas = createSelector(getAddedAreas, (areas) => {
  return areas.reduce(countriesAndAreas, []);
});

export const getSortedCountriesAndAreas = createSelector(
  getCountriesAndAreas,
  (countriesAndAreas) => {
    return countriesAndAreas.sort(sortCountriesAndAreas);
  }
);

export const getSortedAreas = createSelector(getAddedAreas, (areas) => areas.sort((a, b) => a - b));
